import React, { useEffect } from "react";
import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import Login from "./app/Pages/Login";
import PublicLayout from "./app/Layouts/Public-Layouts";
import PrivateLayout from "./app/Layouts/Private-Layouts";
import MainPage from "./app/Pages/index";
import { getLsItem } from "./app/Utils";
import { useAppDispatch } from "./app/hooks";
import { setToken } from "./app/Pages/Login/store/login.Slice";

import SLider from "./app/Pages/Dashboard/tempratureSlider";
import { useNavigate } from "react-router-dom";

function App() {
  const dispatch = useAppDispatch();
  const navigator = useNavigate();

  useEffect(() => {
  
  }, []);

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <PublicLayout>
              <Login />
            </PublicLayout>
          }
        ></Route>
        <Route
          path="/dashboard"
          element={
            <PrivateLayout>
              <MainPage />
            </PrivateLayout>
          }
        ></Route>
        <Route path="*" element={<p>There's nothing here: 404!</p>} />
      </Routes>
    </div>
  );
}

export default App;
